import {
    OnboardDeviceConnectionStatus,
    OnboardDeviceOnlineStatusWsPayload,
    OnboardDevicesOnlinePeersResponse,
} from '../interfaces';

export const ONBOARD_DEVICE_STATUS_WS_EVENT_TYPE = 'onboard_device_online_status';
export const ONBOARD_DEVICE_STATUS_SOURCE_SERVER = 'vpn_server_main';

export const buildInitialOnboardDeviceStatusMap = (
    peersOnline: OnboardDevicesOnlinePeersResponse | null,
): Record<string, OnboardDeviceConnectionStatus> => {
    const statusByDeviceId: Record<string, OnboardDeviceConnectionStatus> = {};

    if (!peersOnline) {
        return statusByDeviceId;
    }

    (peersOnline.vpn_server_main || []).forEach((peer) => {
        if (!peer.deviceId) {
            return;
        }

        if (peer.is_online !== true) {
            return;
        }

        statusByDeviceId[peer.deviceId] = 'online';
    });

    return statusByDeviceId;
};

export const parseOnboardDeviceOnlineStatusWsPayload = (
    data: string,
): OnboardDeviceOnlineStatusWsPayload | null => {
    try {
        const parsedData: unknown = JSON.parse(data);

        if (!parsedData || typeof parsedData !== 'object') {
            return null;
        }

        const payload = parsedData as Partial<OnboardDeviceOnlineStatusWsPayload>;

        if (payload.type !== ONBOARD_DEVICE_STATUS_WS_EVENT_TYPE) {
            return null;
        }

        if (!payload.deviceId || typeof payload.deviceId !== 'string') {
            return null;
        }

        if (payload.status !== 'online' && payload.status !== 'offline') {
            return null;
        }

        return payload as OnboardDeviceOnlineStatusWsPayload;
    } catch (error) {
        return null;
    }
};
